'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import styles from './Usernav.module.scss';
import { getCookie } from 'cookies-next';
import classNames from 'classnames';
import { useEnvContext } from '@/context/envContext';
import { useTranslations } from 'next-intl';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
const UserNav = () => {
  const t = useTranslations('Header');
  const pathname = usePathname();
  const {
    webUrl,
    userUrl,
    cdnEnv
  } = useEnvContext();
  const navUrl = webUrl ? webUrl : 'https://www.techtarget.com';
  const accUrl = userUrl ? userUrl : 'https://users.techtarget.com';
  const fromUrl = encodeURIComponent(navUrl + '/hub' + pathname);
  const crs = getCookie('crs');
  const [isClient, setIsClient] = useState(false);

  // If cdnEnv is undefined use prods hardcoded url path, will happen on notFoumd page
  const userIcon = cdnEnv ? `${cdnEnv}/rms/images/icons/user-icon.svg` : 'https://media.techtarget.com/rms/images/icons/user-icon.svg';
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Only load if you are on client
  if (!isClient) {
    return;
  }

  // If we can see crs/fastpass/uidLoggedIn token, then show logout
  if (crs) {
    return <>
    <div className="comp-brand">
     <a href={`${accUrl}/registration/contenthub/EditProfile.page?fromURL=${fromUrl}`} rel={'nofollow'} onClick={() => {
          pushGTMClickTags({
            click_element: 'Anchor',
            click_section_ID: 'NONE',
            link_id: 'NONE',
            link_text: 'NONE',
            link_url: `${accUrl}/registration/contenthub/EditProfile.page?fromURL=${fromUrl}`,
            click_category: 'NONE',
            click_destination: 'NONE',
            click_closest_href: 'NONE'
          });
        }}>
      <Image src={userIcon} height={11} width={11} className={styles['icon-center-text']} alt="User Avatar" />
     </a>
     <a className={classNames('text-links-body-color', styles['usernav-btn'])} href={`${userUrl}/registration/v2/api/logout?fromURL=${fromUrl}`} onClick={() => {
          pushGTMClickTags({
            click_element: 'Anchor',
            click_section_ID: 'NONE',
            link_id: 'NONE',
            link_text: 'Logout',
            link_url: `${userUrl}/registration/v2/api/logout?fromURL=${fromUrl}`,
            click_category: 'NONE',
            click_destination: 'NONE',
            click_closest_href: 'NONE'
          });
        }}>
      {t('LogoutLink')}
     </a>
    </div>
   </>;
  } else {
    // Show Login if we can't find crs/fastpass/uidLoggedIn token
    return <>
    <div className="comp-brand">
     <a className={classNames('text-links-body-color', styles['usernav-btn'])} href={`${navUrl}/login?fromURL=${fromUrl}`} onClick={() => {
          pushGTMClickTags({
            click_element: 'Anchor',
            click_closest_class: 'comp-brand',
            click_section_ID: 'NONE',
            link_classes: 'text-links-body-color',
            link_id: 'NONE',
            link_text: 'Login',
            link_url: `${navUrl}/login?fromURL=${fromUrl}`,
            click_category: 'NONE',
            click_destination: 'NONE',
            click_closest_href: 'NONE'
          });
        }}>
      {t('LoginLink')}
     </a>
     {pathname.includes('asset') ? '' : <>
       <span className={styles['divider-line']} aria-hidden={'true'}>
        {' '}
        |{' '}
       </span>
       <a className={classNames('text-links-body-color', styles['usernav-btn'])} href={`${navUrl}/register?fromURL=${fromUrl}`} onClick={() => {
            pushGTMClickTags({
              click_element: 'Anchor',
              click_closest_class: 'NONE',
              click_section_ID: 'NONE',
              link_classes: 'text-links-body-color',
              link_id: 'NONE',
              link_text: 'Register',
              link_url: `${navUrl}/register?fromURL=${fromUrl}`,
              click_category: 'NONE',
              click_destination: 'NONE',
              click_closest_href: 'NONE'
            });
          }}>
        {t('RegisterLink')}
       </a>
      </>}
    </div>
   </>;
  }
};
export default UserNav;